import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import Register from "./pages/Register";
import Public from "./pages/Public";
import Framework from "./pages/Framework";
import Contact from "./pages/Contact";
import AssessmentChoice from "./pages/AssessmentChoice";
import Wizard from "./pages/Wizard";
import SystemResult from "./pages/SystemResult";
import RegisterLog from "./pages/RegisterLog";
import Team from "./pages/Team";
import InternalDocuments from "./pages/InternalDocuments";
import Sjabloon from "./pages/Sjabloon";
import SalesApp from "./sales/SalesApp";

const ScrollResetOnRoute = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

// The marketing/assessment site: the RiskaiA chrome (Navigation + Footer)
// wrapping the public + cockpit routes.
function MarketingShell() {
  return (
    <div className="rk-shell" data-testid="app-shell">
      <ScrollResetOnRoute />
      <Navigation />
        <main data-testid="app-main">
          <Routes>
            {/* / — THE LOUNGE */}
            <Route path="/" element={<Home />} />
            {/* /assessment-choice — THE GATE between Lounge and Cockpit */}
            <Route path="/assessment-choice" element={<AssessmentChoice />} />
            {/* /wizard — 6-step intake (Step 1: Organisatie) */}
            <Route path="/wizard" element={<Wizard />} />
            {/* /system/:id — post-assessment outcome page */}
            <Route path="/system/:id" element={<SystemResult />} />
            <Route path="/platform/:id" element={<SystemResult />} />
            {/* /sjabloon/:systemId — official sjabloon intake form (fills the EDT) */}
            <Route path="/sjabloon/:systemId" element={<Sjabloon />} />
            <Route path="/sjabloon" element={<Sjabloon />} />
            {/* /platform — THE COCKPIT (admin / assessment) */}
            <Route path="/platform" element={<Platform />} />
            {/* /register & /publiek-overzicht — admin vs citizen */}
            <Route path="/register" element={<Register />} />
            <Route path="/register/log" element={<RegisterLog />} />
            <Route path="/publiek-overzicht" element={<Public />} />
            {/* /kaders & /framework — supporting framework page */}
            <Route path="/kaders" element={<Framework />} />
            <Route path="/framework" element={<Framework />} />
            {/* /team — De mensen achter RiskaiΛ */}
            <Route path="/team" element={<Team />} />
            {/* /contact */}
            <Route path="/contact" element={<Contact />} />
            {/* /internal/documents — protected internal Markdown→PDF generator
                (Caddy Basic Auth fronts /internal/* at the operations layer) */}
            <Route path="/internal/documents" element={<InternalDocuments />} />
            <Route
              path="*"
              element={
                <div
                  className="rk-container py-40 text-center"
                  data-testid="page-404"
                >
                  <div className="overline mb-4">404</div>
                  <h1
                    className="text-5xl text-white"
                    style={{ fontFamily: "Fraunces, serif", fontWeight: 300 }}
                  >
                    Pagina niet gevonden.
                  </h1>
                </div>
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* /sales/* — Sales Control Center sub-app: its own dark chrome,
            JWT auth and Kanban pipeline, mounted outside the marketing shell. */}
        <Route path="/sales/*" element={<SalesApp />} />
        {/* Everything else: the public RiskaiA site + assessment cockpit. */}
        <Route path="/*" element={<MarketingShell />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
